import { api } from "@/lib/api";

export interface EquipmentLabel {
  id: string;
  artikl_id: string;
  mjesto_id: string;
  inventarni_broj: string;
  naziv: string;
  mjesto: string;
  naljepnica_ispisana_at: string | null;
}
export interface EquipmentLabelSheet {
  id: string;
  content_url: string;
  ispisano_at: string;
}
export interface ScannedEquipment {
  id: string;
  inventarni_broj: string;
  mjesto_id: string;
}
export interface EquipmentLabelFilters {
  artikl?: string;
  mjesto?: string;
  bez_naljepnice?: boolean;
  limit?: number;
  offset?: number;
}
export interface EquipmentLabelPage {
  komadi: EquipmentLabel[];
  ukupno: number;
  limit: number;
  offset: number;
  artikli: { id: string; naziv: string }[];
  mjesta: { id: string; naziv: string }[];
}

export const equipmentLabelsApi = {
  list: async (filters: EquipmentLabelFilters = {}, signal?: AbortSignal) =>
    (
      await api.get<EquipmentLabelPage>("/oprema/naljepnice", {
        signal,
        params: filters,
      })
    ).data,
  create: async (komadi: string[]) =>
    (await api.post<EquipmentLabelSheet>("/oprema/naljepnice", { komadi }))
      .data,
  history: async (signal?: AbortSignal) =>
    (
      await api.get<{ id: string; ispisano_at: string; broj_komada: number }[]>(
        "/oprema/naljepnice/ispisi",
        { signal },
      )
    ).data,
  document: async (id: string, signal?: AbortSignal) =>
    (
      await api.get<Blob>(
        `/oprema/naljepnice/dokumenti/${encodeURIComponent(id)}`,
        { signal, responseType: "blob" },
      )
    ).data,
  resolve: async (value: string, qr: boolean, signal?: AbortSignal) =>
    (
      await api.get<ScannedEquipment>(
        qr
          ? `/oprema/q/${encodeURIComponent(value)}`
          : `/oprema/komadi/po-oznaci/${encodeURIComponent(value)}`,
        { signal },
      )
    ).data,
};

// Resolve cross-environment labels through the local API; never follow the URL.
export function equipmentMark(value: string): { value: string; qr: boolean } {
  const trimmed = value.trim();
  if (!trimmed || trimmed.length > 2048)
    throw new Error(
      "Upišite inventarni broj ili skenirajte QR naljepnicu opreme.",
    );
  if (/^[a-z][a-z0-9+.-]*:/i.test(trimmed) || trimmed.startsWith("/")) {
    let url: URL;
    try {
      url = new URL(trimmed, window.location.origin);
    } catch {
      throw new Error("Ovo nije QR naljepnica ove aplikacije.");
    }
    const match = /^\/oprema\/q\/([A-Za-z0-9_-]+)$/.exec(url.pathname);
    if (!["http:", "https:"].includes(url.protocol) || !match)
      throw new Error("Ovo nije QR naljepnica opreme.");
    return { value: match[1]!, qr: true };
  }
  if (trimmed.length > 100)
    throw new Error(
      "QR oznaka nije valjana. Pokušajte ručno upisati inventarni broj.",
    );
  return { value: trimmed, qr: false };
}
